"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("@mui/styles");
var material_1 = require("@mui/material");
var useStyles = (0, styles_1.makeStyles)({
    captionBlock: {
        display: 'flex',
        width: '100%',
        padding: '10px',
        alignItems: 'center',
        backgroundImage: "linear-gradient(rgba(0,0,0,0.05), rgba(0,0,0,0.8))",
        color: 'white',
        position: 'absolute',
        bottom: '0px',
        left: '0px'
    }
});
var SocialMediaCaption = function (_a) {
    var caption = _a.caption;
    var classes = useStyles();
    return caption ? (react_1.default.createElement("div", { className: classes.captionBlock },
        react_1.default.createElement(material_1.Typography, { variant: 'body1', fontSize: '30px' }, caption))) : null;
};
exports.default = SocialMediaCaption;
//# sourceMappingURL=SocialMediaCaption.js.map